import React from 'react';

import { AddCircleOutline } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

import { EditableListButton, type EditableListButtonProps } from './EditableListButton';

export type AddPageButtonProps = Omit<EditableListButtonProps, 'title' | 'icon' >;

export const AddPageButton = (props: AddPageButtonProps) => {
    const { t } = useTranslation('whiteboard');

    return (
        <EditableListButton
            {...props}
            key={'add-page'}
            title={t('addPage')}
            icon={<AddCircleOutline />}
        />
    );
};
